<template lang="pug">
.events
  h2.h-l.event-title
    | upcoming programs
  .eventsContainer
    .preview(v-for="program in programs")
      router-link(
        :to="{name: 'programs-page', params: {category: programCategory(program), id: program.uid }}"
      )
        .events-hero
          img.cover(:src="program.mainImage" :alt="program.content.title")
        .eventCaptions
          h2.h-m
            | {{ title(program) }}
          .dateTime
            h3.h-sm
              | {{ program.content.date }}
            p.h-sxx
              | {{ program.content.start_time }} - {{ program.content.end_time }}
</template>

<script>
export default {
  name: 'home-events',

  props: ['programs'],

  methods: {
    programCategory: function (item) {
      return item.content.category.split(' ').join('-').toLowerCase()
    },

    title: function (item) {
      const virtual = item.content.virtual === '1' ? ' | virtual program' : ''
      return item.content.title + virtual
    }
  }
}
</script>

<style lang="sass">
@import '../../styles/_variables'
@import '../../styles/_mixins'
.events
  .event-title
    padding-left: 0
    margin-left: $sectionMargin
    margin-bottom: 2rem
    @include respond-to(xs)
      margin-left: 5%
      margin-bottom: 0.5rem
  .eventsContainer
    display: flex
    justify-content: flex-start
    @include respond-to(xs)
      display: block
    .preview
      width: 30%
      margin-left: 2.5vW
      @include respond-to(xs)
        width: 90%
        margin-left: 5%
        margin-bottom: 3rem
      &:hover h2
        border-bottom: solid 2px #000
        @include respond-to(xs)
          border-bottom: none
    .events-hero
      width: 100%
      height: 29vH
      @include respond-to(xs)
        height: 48vW
    .eventCaptions
      margin-top: 1rem
      h2
        display: inline
        border-bottom: solid 2px #FFF
        padding-top: 0.57rem
        @include respond-to(xs)
          border-bottom: none
      p
        @include respond-to(xs)
          &::before
            padding: 0 1rem
            content: '|'
      .dateTime
        @include respond-to(xs)
          display: flex
          justify-content: flex-start
</style>



// WEBPACK FOOTER //
// HomeEvents.vue?13b8cadc